import { createSlice } from '@reduxjs/toolkit';
import AuthService from '../services/AuthService';
// import { isSet } from '../utils/commonUtils';


export const commonSlice = createSlice({
  name: 'common',
  initialState: {
    toasts: [],
    reloadKeyProps:null,
    isLoading:false,
    isSessionIsActive: true, 
    sessionTimeoutId: null,
    isNewUI: (() => { try { const v = localStorage.getItem('isNewUI'); return v !== null ? JSON.parse(v) : true; } catch { return true; } })(), // New UI; default true so incognito/first load uses new theme once
  },
  reducers: {
    showToastAction: (state, action) => {
      const { type, message,id } = action.payload;
      state.toasts.push({ id, type, message });
    },
    hideToast: (state, action) => {
      const id = action.payload;
      state.toasts = state.toasts.filter(toast => toast.id !== id);
    },
    reloadPropsAction: (state,action) => {
      state.reloadKeyProps  = action.payload;
    },
    loader: (state,action=false) => {
      state.isLoading   = action.payload;
      //(isSet(action.payload,null)===null)?!state.isLoading:action.payload
    },
    setSessionIsActive: (state, action) => {
      state.isSessionIsActive = action.payload;
    },
    clearSessionTimeout:(state)=>{
      clearTimeout(state.sessionTimeoutId);
      state.sessionTimeoutId = null;
    },
    setSessionTimeoutId: (state, action) => { 
      state.sessionTimeoutId = action.payload;
    },

    setIsNewUI: (state, action) => {
      localStorage.setItem('isNewUI', JSON.stringify(action.payload))
      state.isNewUI = action.payload;
    }
  },
});

export const { showToastAction, hideToast,loader,setSessionIsActive,clearSessionTimeout,setSessionTimeoutId, reloadPropsAction,setIsNewUI} = commonSlice.actions;
export default commonSlice.reducer;



// Toast utility function
export const success = (message, timeout =2000 ) => (dispatch) => {
  dispatch(showToast({ type: 'success', message, timeout }));
};

export const error = (message, timeout =3000 ) => (dispatch) => {
  dispatch(showToast({ type: 'error', message, timeout }));
};


export const warning = (message, timeout =3000 ) => (dispatch) => {
  dispatch(showToast({ type: 'warning', message, timeout }));
};


export const showToast = ({type, message,timeout}) => (dispatch) => {
  const id = Date.now();
  dispatch(showToastAction({ type, message, id }));
  // Automatically hide the toast after the specified timeout
  setTimeout(() => {
    dispatch(hideToast(id));
  }, timeout);
};


export const resetSessionTimeout = (timeout) => (dispatch, getState) => {
  const { sessionTimeoutId } = getState().common;
  let updateSessionTimeoutId = sessionTimeoutId;
  if (updateSessionTimeoutId!==null){ 
    clearTimeout(updateSessionTimeoutId); 
    updateSessionTimeoutId = null;
    const startTime = Date.now();
    localStorage.setItem('sessionStartTime', startTime.toString());
    localStorage.setItem('sessionTimeoutDuration', timeout.toString());  
  }
  
  updateSessionTimeoutId = setTimeout(() => {
      if (AuthService.isAuthenticated()) {
          dispatch(setSessionIsActive(false));
      }
  }, parseInt(timeout));
  dispatch(setSessionTimeoutId(updateSessionTimeoutId));
}


export const checkSessionTimeout = () => (dispatch) => {
  const startTime       = parseInt(localStorage.getItem('sessionStartTime'));
  const timeoutDuration = parseInt(localStorage.getItem('sessionTimeoutDuration'));

  if (!isNaN(startTime) && !isNaN(timeoutDuration)) {
    const currentTime = Date.now();
    const sessionEndTime = startTime + timeoutDuration;
    // console.log('currentTime',currentTime,sessionEndTime);
    const currentTimeFormatted = new Date(currentTime).toLocaleString();
    const sessionEndTimeFormatted = new Date(sessionEndTime).toLocaleString();
    //console.log('sessionEndTime',currentTimeFormatted);
    //console.log('currentTime',sessionEndTimeFormatted);
    if (currentTime > sessionEndTime) {
      if (AuthService.isAuthenticated()) {
        dispatch(setSessionIsActive(false));
      }
    }
  }
};